<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" :width="100" />
        <table-header :title="$t('category.name')" :minWidth="100" />
        <table-header
          :title="$t('common.action')"
          :minWidth="100"
          :width="100"
        />
      </template>
      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>
          <i class="el-icon-edit icon" @click="handleOpenEditDialog(row)" />
          <i
            class="el-icon-delete icon"
            @click="handleOpenDeleteDialog(row.id)"
          />
        </table-cell>
      </template>
    </table-component>

    <edit-dialog
      :subcategorySelected="subcategorySelected"
      :openEditDialog="openEditDialog"
      @handleCloseEditDialog="handleCloseEditDialog"
    />

    <delete-dialog
      :title="null"
      :content="$t('category.deleteTitle')"
      :openDeleteDialog="openDeleteDialog"
      :deleteLoading="deleteSubcategoryLoading"
      @handleCloseDialog="handleCloseDeleteDialog"
      @handleConfirm="handleDeleteCategory"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { subcategoryService } from '@/services/subcategory.service';
import { handleError, notifyMessage, redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';

const EditDialog = () => import('../EditSubcategoryDialog');
const DeleteDialog = () => import('@/components/Dialog/DialogConfirm.vue');

export default {
  name: 'TableListSubcategory',
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  components: { EditDialog, DeleteDialog },
  data() {
    return {
      deleteSubcategoryLoading: false,
      subcategoryIdSelected: null,
      subcategorySelected: null,
      openDeleteDialog: false,
      openEditDialog: false,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('subcategory', ['subcategory']),
  },
  methods: {
    ...mapActions('subcategory', ['getSubcategoryList']),
    handleOpenDeleteDialog(subcategoryId) {
      this.subcategoryIdSelected = subcategoryId;
      this.openDeleteDialog = true;
    },
    handleCloseDeleteDialog() {
      this.openDeleteDialog = false;
    },
    handleDeleteCategory() {
      this.deleteSubcategoryLoading = true;

      subcategoryService
        .delete(this.subcategoryIdSelected)
        .then(() => {
          const subcategoryLength = this.subcategory.data.length - 1;
          this.getSubcategoryList({
            categoryId: this.$router.currentRoute.params.id,
            params: {
              name: this.$route.query.name,
              page:
                subcategoryLength === 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page || PAGE,
              limit: LIMIT,
            },
          });
          redirectRouter({
            path: `/categories/${this.$router.currentRoute.params.id}/sub-categories`,
            query: {
              ...this.$route.query,
              page:
                subcategoryLength === 0 && +this.$route.query.page > 1
                  ? +this.$route.query.page - 1
                  : this.$route.query.page,
            },
          });
          this.openDeleteDialog = false;
          notifyMessage(this.$t('common.deleteSuccess'), 'success');
        })
        .catch((error) => {
          handleError(error);
        })
        .finally(() => {
          this.deleteSubcategoryLoading = false;
        });
    },
    handleOpenEditDialog(subcategory) {
      this.subcategorySelected = subcategory;
      this.openEditDialog = true;
    },
    handleCloseEditDialog() {
      this.openEditDialog = false;
    },
    handleViewDetail(id) {
      redirectRouter(`/categories/${id}`);
    },
  },
};
</script>
